import React, { useState } from 'react';
import { formatNumber } from '../utils';
import StockItemActionModal from '../StockItemActionModal';
import BookingModal from '../BookingModal';

export default function OverRunsPage({ items, customers, overRunsClientFilter, setOverRunsClientFilter, onEdit, onDelete, onItemAction: _onItemAction, setItems }) {
  // Show only items with minQty === 0 (original Over Runs logic)
  const overRunItems = items.filter(i => Number(i.minQty) === 0);
  // Optionally filter by client
  const filteredItems = overRunsClientFilter === 'ALL'
    ? overRunItems
    : overRunItems.filter(i => i.clientId === overRunsClientFilter);
  const [actionModal, setActionModal] = useState({ open: false, item: null });
  const [bookingModal, setBookingModal] = useState({ open: false, item: null });

  // Handler for row click
  function handleRowClick(item) {
    setActionModal({ open: true, item });
  }

  // After booking, refresh items
  async function handleBookingSuccess() {
    setBookingModal({ open: false, item: null });
    // Refetch items from backend and update parent state
    const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/items`);
    const updatedItems = await res.json();
    if (typeof setItems === 'function') setItems(updatedItems);
  }

  return (
    <div style={{width:'100%',maxWidth:1200,margin:'0 auto',marginTop:24,background:'#fff',borderRadius:24,boxShadow:'0 2px 12px #1976d222',padding:32}}>
      <div style={{display:'flex', alignItems:'center', marginBottom:14}}>
        <h3 style={{marginTop:0,marginBottom:0,color:'#1976d2',fontWeight:700,fontSize:'1.25rem',letterSpacing:1,marginRight:18}}>Over Runs</h3>
        <select
          value={overRunsClientFilter}
          onChange={e => setOverRunsClientFilter(e.target.value)}
          style={{
            fontSize:15,
            borderRadius:8,
            border:'1px solid #1976d2',
            padding:'6px 16px',
            fontWeight:600,
            color:'#1976d2',
            background:'#f8fafc',
            marginLeft:4,
            outline:'none',
            boxShadow:'0 1px 6px #1976d211',
            cursor:'pointer'
          }}
        >
          <option value="ALL">All Customers</option>
          {Array.from(new Set(overRunItems.map(i => i.clientId)))
            .map(cid => {
              const cust = customers.find(c => c.id === cid);
              return cust ? <option key={cust.id} value={cust.id}>{cust.name}</option> : null;
            })}
        </select>
      </div>
      {/* Table of over run items */}
      <div style={{display:'flex',justifyContent:'flex-end',alignItems:'center',marginBottom:10}}>
        <span style={{fontWeight:700,fontSize:18,color:'#1976d2',background:'#e3f2fd',padding:'8px 22px',borderRadius:10,boxShadow:'0 1px 4px #1976d211'}}>Grand Total Value: {(() => {
          const total = filteredItems.reduce((sum, i) => sum + ((i.currentQty * i.cost) / 1000 || 0), 0);
          return `R${formatNumber(total)}`;
        })()}</span>
      </div>
      <table style={{width:'100%',marginTop:16}}>
        <thead>
          <tr>
            <th style={{padding:'0 18px'}}>Customer</th>
            <th style={{padding:'0 18px'}}>Product Code</th>
            <th style={{padding:'0 18px'}}>Description</th>
            <th style={{padding:'0 18px'}}>Variant</th>
            <th style={{padding:'0 18px'}}>Label Size</th>
            <th style={{padding:'0 18px'}}>Current Qty</th>
            <th style={{padding:'0 18px'}}>Cost (R/1000)</th>
            <th style={{padding:'0 18px'}}>Total Value</th>
            <th style={{padding:'0 18px'}}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredItems.map(i => (
            <tr key={i.id}
              style={{cursor:'pointer',transition:'background 0.13s'}}
              onClick={e => {
                if (e.target.tagName !== 'BUTTON') handleRowClick(i);
              }}
              onMouseOver={e => e.currentTarget.style.background = '#e3f2fd'}
              onMouseOut={e => e.currentTarget.style.background = ''}
            >
              <td style={{padding:'0 18px',whiteSpace:'nowrap',maxWidth:160,overflow:'hidden',textOverflow:'ellipsis'}}>{i.client ? i.client.name : ''}</td>
              <td style={{padding:'0 18px'}}>{i.productCode}</td>
              <td style={{padding:'0 18px'}}>{i.mainCategory}</td>
              <td style={{padding:'0 18px'}}>{i.variantDesc}</td>
              <td style={{padding:'0 18px'}}>{i.labelSize}</td>
              <td style={{padding:'0 18px'}}>{formatNumber(i.currentQty)}</td>
              <td style={{padding:'0 18px'}}>{i.cost ? `R${formatNumber(i.cost)}` : '-'}</td>
              <td style={{padding:'0 18px'}}>{i.cost ? `R${formatNumber((i.currentQty * i.cost) / 1000)}` : '-'}</td>
              <td style={{padding:'0 18px'}}>
                <div style={{display:'flex',gap:8,flexWrap:'nowrap'}}>
                  <button onClick={e => { e.stopPropagation(); onEdit(i); }}>Edit</button>
                  <button
                    onClick={e => { e.stopPropagation(); if (i.currentQty === 0) onDelete(i); }}
                    style={{opacity: i.currentQty === 0 ? 1 : 0.5, cursor: i.currentQty === 0 ? 'pointer' : 'not-allowed'}}
                    disabled={i.currentQty !== 0}
                    title={i.currentQty !== 0 ? 'Cannot delete: Current Qty must be 0' : 'Delete this item'}
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="8" style={{textAlign:'right',fontWeight:600}}>Grand Total Value:</td>
            <td colSpan="2" style={{fontWeight:700,color:'#1976d2'}}>
              {(() => {
                const total = filteredItems.reduce((sum, i) => sum + ((i.currentQty * i.cost) / 1000 || 0), 0);
                return `R${formatNumber(total)}`;
              })()}
            </td>
          </tr>
        </tfoot>
      </table>
    <StockItemActionModal
      open={actionModal.open}
      item={actionModal.item}
      onClose={() => setActionModal({ open: false, item: null })}
      onCheckIn={null} // Disable Check In for Over Runs
      onCheckOut={item => {
        setActionModal({ open: false, item: null });
        _onItemAction && _onItemAction(item); // fallback to parent handler
      }}
      onBook={item => {
        setActionModal({ open: false, item: null });
        setBookingModal({ open: true, item });
      }}
    />
    <BookingModal
      open={bookingModal.open}
      item={bookingModal.item}
      onClose={() => setBookingModal({ open: false, item: null })}
      onSuccess={handleBookingSuccess}
    />
    </div>
  );
}
